import React from "react";
import AboutSection from "../components/AboutSection";
import FaqSection from "../components/FaqSection";
import ServicesSection from "../components/ServicesSection";
import OurSuccess from "../components/OurSuccess";
import ScrollTop from "../components/ScrollTop";
// Animations
import { motion } from "framer-motion";
import { pageAnimation } from "../animation";
import ContactForm from "../components/ContactForm";
import AboutUsSection from "../components/AboutUsSection"; // Adjust the path as necessary


const AboutUs = () => {
  return (
    <motion.div
      variants={pageAnimation}
      initial="hidden"
      animate="show"
      exit="exit"
    >
      <ScrollTop />
      <AboutSection />
      <ServicesSection />
      <OurSuccess />
      <div style={{height: "5rem"}}></div>
      <AboutUsSection />   
      <FaqSection />

      {/* Add the About Section */}
      <ContactForm />
      
    </motion.div>
  );
};

export default AboutUs;
